import { authorizedGET, authorizedPOST, authorizedPUT, authorizedDELETE } from '../helpers/requester';
import endpoints from '../constants/endpoints';

import { default as dsps } from './dsps';
import { default as ssps } from './ssps';
import { default as sellerInfo } from './sellerInfo';
import { default as users } from './users';
import { default as statistics } from './statistics';
import { default as globalLists } from './globalLists';
import { default as samples } from './samples';
import { default as documentation } from './documentation';
import { createWhiteAndBlackLists } from './whiteAndBlackLists';
import { createStatisticsV2 } from './statisticsV2';
import { createPredictionsV2 } from './predictionsV2';
import { createUsersyncStatistics } from './usersyncStatistics';
import { createResponseTimeStatistics } from './responseTimeStatistics';

export type Requester = {
  authorizedGET: <T>(url: string) => Promise<T>;
};

export const createApiGateway = () => {
  const requester = {
    authorizedGET,
    authorizedPOST,
    authorizedPUT,
    authorizedDELETE,
  };

  return {
    dsps: dsps(requester, endpoints),
    ssps: ssps(requester, endpoints),
    sellerInfo: sellerInfo(requester, endpoints),
    users: users(requester, endpoints),
    statistics: statistics(requester, endpoints),
    statisticsV2: createStatisticsV2(requester, endpoints),
    usersyncStatistics: createUsersyncStatistics(requester, endpoints),
    responseTimeStatistics: createResponseTimeStatistics(requester, endpoints),
    predictionsV2: createPredictionsV2(requester, endpoints),
    whiteAndBlackLists: createWhiteAndBlackLists(requester, endpoints),
    globalLists: globalLists(requester, endpoints),
    samples: samples(requester, endpoints),
    documentation: documentation(requester, endpoints),
    ...requester,
  };
};

export default createApiGateway;
